import { Input, Select, TextArea } from 'common/InputForm';
import { CustomModal } from 'components/modals/ModalBox';
import useButtonLoader from 'hooks/useButtonLoader';
import React, { useState } from 'react'
import { changeStatusRefillApi } from 'services/user';

const ChangeStatus = ({ show, close, statusData, refillList = () => { }, userId }) => {
    const [error, setError] = useState({});
    const [buttonLoader, setButtonLoader] = useButtonLoader("submit");
    const [input, setInput] = useState({
        status: "",
        rejectionReason: '',
    })
    // console.log('statusData', statusData)
    // -----------handle-close----------------
    const modalClose = (e) => {
        close()
        setInput({ status: "", rejectionReason: '', })
        setError({})
    };
    // -----------modal-onchange----------------
    const handleChange = (e) => {
        const { name, value } = e.target;
        const noLeadSpace = value.replace(/^\s+/, '');
        setInput({ ...input, [name]: noLeadSpace });
    };
    // ------------validation-----------------
    const validation = () => {
        let errorMessage = {};
        let status = true;

        if (!input.status) {
            errorMessage['status'] = 'Please Select status';
            status = false;
        }

        if (input?.status === 'REJECTED' && !input.rejectionReason) {
            errorMessage['rejectionReason'] = 'Please enter Reject Reason';
            status = false;
        }
        setError(errorMessage);
        return status;
    };
    // ------------add-promo-code-API--------------------
    const changeStatus = async () => {
        if (validation()) {
            try {
                const payLoad = {
                    userId: userId,
                    reFillOrderId: statusData?._id,
                    status: input?.status || '',
                    ...(input?.status==='REJECTED' && { rejectionReason: input?.rejectionReason })
                }
                setButtonLoader(true)
                const res = await changeStatusRefillApi(payLoad)
                const { code, message } = res?.data;
                if (code === 200) {
                    // toastMessage(message, 'success', 'addPromoCode')
                    refillList()
                    modalClose()
                }
            } catch (e) {
                console.log('e', e)
            } finally {
                setButtonLoader(false)
            }
        }
    }
    return (
        <CustomModal
            className={"add_model"}
            show={show}
            handleClose={modalClose}
        >
            <h3>Change Status</h3>
            <div className="form_field_wrap">
                <div className="form_field">
                    <Select
                        type="text"
                        label="Status"
                        name="status"
                        value={input?.status}
                        onChange={handleChange}
                        error={error.status}
                    >
                        <option value="" disabled>select Status</option>
                        <option value="APPROVED">Approve</option>
                        <option value="REJECTED">Reject</option>
                    </Select>
                </div>
            </div>
            {input?.status === 'REJECTED' &&
                <div className="form_field_wrap">
                    <div className="form_field">
                        <TextArea
                            type="text"
                            label="Reject Reason"
                            name="rejectionReason"
                            placeholder='Please enter your reason'
                            value={input?.rejectionReason}
                            onChange={handleChange}
                            error={error.rejectionReason}
                        />
                    </div>
                </div>}


            <div className="button_wrap">
                <button
                    type="button"
                    className="button light"
                    onClick={modalClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    ref={buttonLoader}
                    onClick={changeStatus}
                    className="button"
                >
                    Submit
                </button>
            </div>
        </CustomModal>
    )
}

export default ChangeStatus